import { render, staticRenderFns } from "./TopProducts.vue?vue&type=template&id=e0fe648c&scoped=true&"
import script from "./TopProducts.vue?vue&type=script&lang=js&"
export * from "./TopProducts.vue?vue&type=script&lang=js&"
import style0 from "./TopProducts.vue?vue&type=style&index=0&id=e0fe648c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fe648c",
  null
  
)

export default component.exports